import { render, staticRenderFns } from "./BundleMapping.vue?vue&type=template&id=4a18432a&scoped=true"
import script from "./BundleMapping.vue?vue&type=script&lang=ts"
export * from "./BundleMapping.vue?vue&type=script&lang=ts"
import style0 from "./BundleMapping.vue?vue&type=style&index=0&id=4a18432a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18432a",
  null
  
)

export default component.exports